module.exports = __webpack_public_path__ + "media/images/image-placeholder-2-5b4e5f67eaa946fd23dcecfcf027ecfa.jpg";